/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2023-2024 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import { AppMsg } from "../utils";
import isEmpty from "lodash/isEmpty";

export const ChangePasswordService = {
  initPasswordRules,
  changePassword,
  initCustomPasswordRules,
};

const NEW_PWD_VALIDATION = false;

function initPasswordRules() {
  return fetch("../../p/websignon/tririga-pwd-rules").then((response) => {
    return response.json().then((data) => {
      return data.passwordRules;
    });
  });
}

function initCustomPasswordRules(username) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ userName: username }),
  };
  return fetch(
    "../../p/websignon/tririga-custom-pwd-rules",
    requestOptions
  ).then((response) => {
    return response.json().then((data) => {
      return parseCustomPasswordRule(data.customPasswordRules);
    });
  });
}

function parseCustomPasswordRule(customRules) {
  if (isEmpty(customRules)) return [];

  const rulesArray = [];
  let currentRule = "";

  for (let i = 0; i < customRules.length; i++) {
    const currentChar = customRules[i];

    if (currentChar === "," && !isWithinQuotes(customRules, i)) {
      rulesArray.push(currentRule.trim());
      currentRule = "";
    } else {
      currentRule += currentChar;
    }
  }

  rulesArray.push(currentRule.trim());

  return rulesArray.filter((rule) => !isEmpty(rule));
}

function isWithinQuotes(customRules, index) {
  let singleQuotes = false;
  let doubleQuotes = false;

  if (
    previousNonSpaceChar(customRules, index) === "'" &&
    nextNonSpaceChar(customRules, index) === "'"
  ) {
    singleQuotes = !singleQuotes;
  } else if (
    previousNonSpaceChar(customRules, index) === '"' &&
    nextNonSpaceChar(customRules, index) === '"'
  ) {
    doubleQuotes = !doubleQuotes;
  }

  return singleQuotes || doubleQuotes;
}

function nextNonSpaceChar(customRules, index) {
  const trimmedSubstring = customRules.substring(index + 1).trim();

  return trimmedSubstring.charAt(0) || null;
}

function previousNonSpaceChar(customRules, index) {
  if (index <= 0 || index >= customRules.length) {
    return null;
  }

  const trimmedSubstring = customRules.substring(0, index).trim();

  return trimmedSubstring.slice(-1) || null;
} 

function changePassword(
  username,
  oldPassword,
  newPassword,
  confirmNewPassword
) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      userName: username,
      oldPassword: oldPassword,
      newPassword: newPassword,
      confirmNewPassword: confirmNewPassword,
      isCurrentPasswordValidationOnly: NEW_PWD_VALIDATION,
    }),
  };

  return fetch("../../p/websignon/tririga-change-pwd", requestOptions).then(
    handlePasswordChangeResponse
  );
}

function handlePasswordChangeResponse(response) {
  if (!response.ok) {
    if (response.status === 401) {
      return response.text().then((text) => {
        let messageIndex = text.indexOf(": ");
        let errorMessage =
          messageIndex > -1 ? text.slice(messageIndex + 2) : text;
        return Promise.reject(errorMessage);
      });
    } else {
      return Promise.reject(AppMsg.getMessage(AppMsg.APP_SYSTEM_ERROR_PWD));
    }
  } else {
    return Promise.resolve();
  }
}
